import { ENDPOINT } from "../../api/endpoint";
import fetchWrapper from "../../api/fetchWrapper";

export const notificationData = async () => {
  const response = await fetchWrapper(ENDPOINT.GET_NOTIFICATION_DATA, {
    method: "GET",
  });

  return response;
};
